export default function genererDelaiReglementDetail() {
  return {
    nombreJourDecalage: null,
    finDeMois: null,
    jourFinDeMois: null,
  };
}



// WEBPACK FOOTER //
// ./src/services/devis/genererDelaiReglementDetail.js